<template>
<header
	class="navbar navbar-dark fixed-top bg-gradient flex-md-nowrap p-0 shadow"
>
	<div class="navbar-brand fs-4 w-100 me-0" :class="{ 'navbar-brand-mobile': !isDesktop }">
		<span class="font-monospace fw-normal" :class="{ 'ms-2': isDesktop }">
			{{ organization_name }}
		</span>
	</div>
</header>
</template>


<script>
import { useSizeBreakpoint } from '@/composables/size-breakpoint.js'

export default {
	inject: ['headerHeight'],

	components: {},

	props: {
		organization_name: {
			type: String,
			required: true,
			default: '\u00A0\u00A0\u00A0',
		},
	},

	emits: {},

	setup() {
		const { isDesktop } = useSizeBreakpoint()

		return {
			isDesktop,
		}
	},

	data() {
		return {}
	},

	created() {},

	methods: {},
}
</script>


<style scoped>
/*
  * Navbar
  */
.navbar {
	height: v-bind(headerHeight);
	position: sticky;
	background-color: #00003b !important;
}

.navbar-brand {
	padding-left: 6rem;
	background-color: rgba(0, 0, 0, .25);
	box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
}

.navbar-brand-mobile {
	padding-left: 0;
	text-align: center;
}

.navbar .form-control {
	padding: .75rem 1rem;
	background-color: transparent !important;
}

.form-control-dark {
	color: #fff;
	background-color: rgba(255, 255, 255, .1);
	border-color: rgba(255, 255, 255, .1);
}
</style>